import React from 'react'
import './titleDesk.css'

export default function TitleDesk ({ title, ...props }) {
  return <h1 className='bpp-titleDesk' {...props}>{title}</h1>
}
